import React, { SyntheticEvent, useMemo } from 'react'
import Link from 'next/link'
import RadarChart from './radar-chart'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import Stars from './stars'

const star = require('static/star@3x.png')
const star_black = require('static/star-black@3x.png')

const quoter = require('static/6.png')
const quoter2 = require('static/6@2x.png')
const quoter3 = require('static/6@3x.png')

interface CarReview {
  series_id: number
  series_name: string
  author_info: {
    user_id: number
    user_name: string
    avatar_url: string
  }
  related_group_id: {
    group_count: number
    group_list: [string]
  }
  score: number
  content: string
  comfort_score: number
  appearance_score: number
  configuration_score: number
  control_score: number
  power_score: number
  space_score: number
  interiors_score: number
  cover_url: string
}
export default function ValueCard(props: CarReview) {
  let mark_text = ''
  const {
    score,
    author_info,
    series_name,
    series_id,
    content,
    cover_url,
    appearance_score,
    power_score,
    control_score,
    comfort_score,
    space_score,
    configuration_score,
    interiors_score,
    related_group_id,
  } = props
  const group_id = related_group_id.group_list[0] || ''
  if (score < 100) {
    mark_text = '极差'
  } else if (score < 200) {
    mark_text = '较差'
  } else if (score < 300) {
    mark_text = '一般'
  } else if (score < 400) {
    mark_text = '良好'
  } else if (score <= 500) {
    mark_text = '优秀'
  }

  const review_detail_url = `/article/${group_id}`
  const car_profile_url = `/auto/series/${series_id}`
  const author_profile_url = `/user/ugc_profile/${author_info.user_id}`

  const max = 500

  const option = useMemo(
    () => ({
      title: {
        text: (score / 100).toFixed(2),
        x: 'center',
        y: 'center',
        textStyle: {
          color: '#000000',
          fontSize: 18,
          fontWeight: 'bold',
        },
      },
      radar: {
        // shape: 'circle',
        textStyle: {
          color: '#1f2129',
          fontSize: 10,
          lineHeight: 1.4,
        },
        indicator: [
          { name: '外观', max },
          { name: '动力', max },
          { name: '操控', max },
          { name: '舒适性', max },
          { name: '空间', max },
          { name: '配置', max },
          { name: '内饰', max },
        ],
        radius: 32,
        splitNumber: 3,
        silent: true,
        nameGap: 6,
        shape: 'circle',
        splitArea: {
          areaStyle: {
            color: '#f7f8fc',
          },
        },
        name: {
          textStyle: {
            color: '#1f2129',
            fontSize: 10,
            lineHeight: 14,
          },
        },
        splitLine: {
          lineStyle: {
            color: '#e6e8f2',
            width: 0.5,
          },
        },
        axisLine: {
          lineStyle: {
            color: '#e6e8f2',
            width: 0.5,
          },
        },
      },
      series: [
        {
          type: 'radar',
          // areaStyle: {normal: {}},
          symbol: 'none',
          areaStyle: {
            normal: {
              color: 'rgba(255,205,50,0.4)',
            },
          },
          lineStyle: {
            normal: {
              width: 2,
              color: '#ffcd32',
            },
          },

          data: [
            {
              value: [
                appearance_score,
                power_score,
                control_score,
                comfort_score,
                space_score,
                configuration_score,
                interiors_score,
              ],
            },
          ],
        },
      ],
    }),
    [
      score,
      appearance_score,
      power_score,
      control_score,
      comfort_score,
      space_score,
      configuration_score,
      interiors_score,
    ]
  )

  return (
    <div
      className="card"
      onClick={(e: SyntheticEvent) => {
        const target = e.target as HTMLElement
        let position = ''
        const classListValue = target?.classList?.value
        if (
          classListValue?.includes('avatar') ||
          classListValue?.includes('author-name')
        ) {
          position = 'author'
        } else if (
          classListValue?.includes('car-name') ||
          classListValue?.includes('car-cover')
        ) {
          position = 'car'
        } else if (
          classListValue?.includes('content') ||
          classListValue?.includes('quoter') ||
          classListValue?.includes('radar-chart')
        ) {
          position = 'article'
        }
        if (position !== '') {
          sendTeaCommEvent('click_dcar_score_card', {
            evaluate_card_clk_position: position,
            group_id: related_group_id.group_list[0],
          })
        }
      }}
    >
      <div className="first-line">
        <Link href={author_profile_url}>
          <a target="_blank">
            <img className="avatar" alt="avatar" src={author_info.avatar_url} />
          </a>
        </Link>
        <span className="first-line-text">
          <Link href={author_profile_url}>
            <a target="_blank">
              <span className="author-name">{`${author_info.user_name} `}</span>
            </a>
          </Link>

          <span className="ping">评</span>
          <Link href={car_profile_url}>
            <a target="_blank">
              <span className="car-name">{` ${series_name}`}</span>
            </a>
          </Link>
        </span>
      </div>
      <div className="second-line">
        <div className="stars">
          <Stars
            starIcon={star}
            starVacantIcon={star_black}
            className="stars"
            score={score / 100.0}
            maxScore={5}
            starWidth={12}
            starHeight={12}
          />
        </div>
        <span className="mark">{(score / 100.0).toFixed(1)}</span>
        <span className="mark-text">{mark_text}</span>
      </div>
      <div className="third-line">
        <Link href={review_detail_url}>
          <a target="_blank">
            <p className="content">
              <img
                className="quoter"
                src={quoter}
                srcSet={`${quoter2}, ${quoter3}`}
                alt="quoter"
              />
              {content}
            </p>
          </a>
        </Link>
      </div>
      <Link href={car_profile_url}>
        <a target="_blank">
          <img className="car-cover" alt="car image" src={cover_url} />
        </a>
      </Link>
      <RadarChart
        className="radar-chart"
        option={option}
        jumpTo={review_detail_url}
      />
      <style jsx>
        {`
          .card {
            width: 377px;
            height: 100%;
            border-radius: 2px;
            background-color: white;
            margin-left: 16px;
            display: inline-block;
            vertical-align: top;
            padding-top: 24px;
            padding-left: 12px;
            position: relative;
          }
          .first-line {
            text-overflow: ellipsis;
            font-size: 16px;
            font-weight: 500;
            line-height: 1.25;
            color: #1f2129;
            max-width: 237px;
            -webkit-line-clamp: 2;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
          .first-line-text {
            vertical-align: middle;
          }
          .avatar {
            display: inline-block;
            margin-right: 4px;
            width: 20px;
            height: 20px;
            border: solid 0.5px #e6e8f2;
            cursor: pointer;
            vertical-align: middle;
            border-radius: 50%;
          }
          .author-name,
          .car-name {
            cursor: pointer;
          }
          .author-name:hover,
          .car-name:hover {
            color: #e65800;
          }
          .ping {
            color: #979aa8;
          }
          .second-line {
            margin-top: 11px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            height: 12px;
            position: relative;
          }
          .stars {
            width: 64px;
            height: 100%;
          }

          :global(.stars .star) {
            margin-right: 1px;
          }

          .mark {
            font-size: 14px;
            font-weight: bold;
            line-height: 1.29;
            color: #1f2129;
            margin-left: 4px;
          }
          .mark-text {
            font-size: 12px;
            line-height: 1.5;
            color: #1f2129;
            margin-left: 4px;
          }

          .car-cover {
            position: absolute;
            top: 12px;
            right: 12px;
            width: 108px;
            height: 72px;
            cursor: pointer;
            transition: transform 0.3s ease-in-out;
          }
          .car-cover:hover {
            transform: scale(1.1);
          }
          .third-line {
            position: absolute;
            top: 94px;
            left: 12px;
            width: 226px;
          }

          .quoter {
            width: 20px;
            height: 20px;
            object-fit: contain;
            opacity: 0.6;
            margin-right: 2px;
            vertical-align: bottom;
          }

          .content {
            font-size: 14px;
            line-height: 22px;
            color: #1f2129;
            max-height: 88px;
            -webkit-line-clamp: 4;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipse;
            cursor: ${group_id === '' ? 'auto' : 'pointer'};
            word-break: break-all;
          }

          :global(.radar-chart) {
            position: absolute;
            bottom: 0;
            right: 0;
            height: 122px;
            width: 139px;
            overflow: visible;
          }
        `}
      </style>
    </div>
  )
}
